import { atom } from 'jotai';

export type MCPBridgeStatus =
  { kind: 'disconnected'; reason?: string } | { kind: 'connecting' } | { kind: 'connected' };

export const mcpBridgeStatusAtom = atom<MCPBridgeStatus>({ kind: 'disconnected' });
